


















import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class AppTextarea extends Vue {
  @Prop(String) readonly value!: string;
  @Prop(String) readonly label!: string;
  @Prop({ type: String }) readonly placeholder!: string;
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop({ type: [Number, String], default: 289 }) readonly width!:
    | number
    | string;

  @Prop({ type: [Number, String], default: 36 }) readonly height!:
    | number
    | string;

  model = '';

  rules = {
    required: (value: string) => !!value || 'Required.'
  };

  mounted () {
    this.model = this.value
  }

  @Emit('input')
  valueChangedHandler (val: string) {
    this.model = val
    return val
  }
}
